import { Modal, ModalBody, ModalFooter } from "react-bootstrap";
import Button from "../../form-components/Button";
import { useSelector } from "react-redux";
import Loader from "../../../common/loader/Loader";
import UppyComponent from "../UppyComponent";
import { useState } from "react";
import CrawlComponent from "../CrawlComponent";
import docimg from "../../../assets/images/web-crawler.svg";
import activedocimg from "../../../assets/images/web-crawler-active.svg";
import spiderimg from "../../../assets/images/spiderimg.svg";
import activespiderimg from "../../../assets/images/spiderimg_active.svg";

const UploadDocumentModal = ({
  isOpen,
  toggle,
  perPage = 10,
  currentPage = 1,
  setSubCategories,
}) => {
  const { isLoading } = useSelector((state) => ({
    isLoading: state?.uploadDocumentReducer?.isLoading,
  }));

  const [documentCategory, setDocumentCategory] = useState("uploadDocument");

  // const createNewDoc = async (value) => {
  //   let formData = new FormData();
  //   value.selectedDocs.map((data) => {
  //     formData.append("documents", data);
  //   });
  //   formData.append("type", "doc");
  //   formData.append("project_uuid", projectData?.projects[0]?.uuid);
  //   const { payload } = await dispatch(uploadDocumentData(formData));
  //   if (payload.status === OK) {
  //     showSuccess(payload.data.message);
  //     toggle();
  //     setSubCategories("Documents");
  //     dispatch(
  //       getDocuments({
  //         perPage: perPage,
  //         page: currentPage,
  //         project_uuid: projectData?.projects[0]?.uuid,
  //       })
  //     );
  //   }
  // };

  // const getDocImg = (type) => {
  //   const lastElement = type.split("/").pop();
  //   switch (lastElement) {
  //     case "pdf":
  //       return pdf;
  //     default:
  //       return doc;
  //   }
  // };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Modal
          className="add-document-popup"
          show={isOpen}
          onHide={toggle}
          // modalTransition={{ timeout: 2000 }}
          dialogClassName="common-modal"
          centered={true}
        >
          <Modal.Header>
            <h3 className="modal-title" id="Add_OrganizationLabel">
              Upload Documents
            </h3>
            <Button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={toggle}
            ></Button>
          </Modal.Header>
          <ModalBody className="p-0">
            <div className="main-doc-div">
              <ul className="left-doc-content">
                <li className={`${documentCategory === "uploadDocument" ? "active" : ""}`} onClick={() => setDocumentCategory("uploadDocument")}>
                  <span className="left-doc-icn">
                    <img src={documentCategory === "uploadDocument" ? activedocimg : docimg} />
                  </span>
                </li>
                <li className={`${documentCategory === "crawlDocument" ? "active" : ""}`} onClick={() => setDocumentCategory("crawlDocument")}>
                  <span className="left-doc-icn">
                    <img src={documentCategory === "crawlDocument" ? activespiderimg : spiderimg} />
                  </span>
                </li>
              </ul>
              <div className="right-doc-content pb-3">
                {documentCategory === "uploadDocument" && (
                  <UppyComponent
                    toggle={toggle}
                    setSubCategories={setSubCategories}
                  />
                )}
                {documentCategory === "crawlDocument" && (
                  <CrawlComponent
                    toggle={toggle}
                    setSubCategories={setSubCategories}
                  />
                )}
              </div>
            </div>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default UploadDocumentModal;
